export const messages = {
    wronggame: {
        title: 'Gra nie istnieje',
        message:
            'Taka gra nie istnieje, zaloguj się do panelu trenera i spróbuj jeszcze raz',
        event: 'wronggame',
    },
    wrongcode: {
        title: 'Konflikt urządzeń',
        message:
            'Prawdopodobnie gra została uruchomiona na innym urządzeniu. Jeśli chcesz ją przenieść na to urządzenie, zaloguj się do panelu trenera i użyj odpowiedniej opcji',
        event: 'wronggcode',
    },
    expired: {
        title: 'Gra zakończona',
        message:
            'Prawdopodobnie minął czas na grę. Zaloguj się do panelu trenera i sprawdź swoją listę gier',
        event: 'wronggcode',
    },
    missingcredentials: {
        title: 'Brak danych gry',
        message:
            'Prawdopodobnie próbujesz uruchomić gre przez przeklejenie linka na inne urządzenie. Zaloguj się do panelu trenera i uruchom grę',
        event: 'wronggcode',
    },
    diceTitle: 'Rzuć jedną kością i wybierz wynik',
    diceOr: 'LUB',
};
export const pl = {
    tutorial: {
        Vipers: {
            name: 'Gniazdo żmij',
            effect: 'display',
            protection: 'careful',
            protectedKarma: 1,
            badKarma1: 6,
            badKarma2: 'nie dotyczy',
            badKarma3: 'nie dotyczy',
            badKarma4: 'nie dotyczy',
            badKarma5: 'nie dotyczy',
            badKarma6: 'nie dotyczy',
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Ostrożnie przemieszczasz się przez zarośla. Słyszysz ciche szelesty w pobliskich krzakach, jednak wszystko się uspokaja kiedy powoli oddalasz się w swoją stronę.',
            badDescription1:
                'Mijasz pobliskie zarośla, podśpiewując sobie dla dodania animuszu. Wtem dosięga Cię mściwy syk! Nim zdążyłeś uskoczyć, żmija rzuciła się na Twoje łydki i dotkliwie Cię pokąsała.',
            badDescription2: 'nie dotyczy',
            badDescription3: 'nie dotyczy',
            badDescription4: 'nie dotyczy',
            badDescription5: 'nie dotyczy',
            badDescription6: 'nie dotyczy',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Shrubbery: {
            name: 'Kolczaste krzaki',
            effect: 'display/toss',
            protection: 'none',
            protectedKarma: 1,
            badKarma1: 1,
            badKarma2: 1,
            badKarma3: 1,
            badKarma4: 1,
            badKarma5: 1,
            badKarma6: 1,
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Przy drodze rośnie wiele kolczastych roślin, o które łatwo się pokaleczyć. Udało Ci się jednak uniknąć kłopotów.',
            badDescription1:
                'Przy drodze rośnie wiele kolczastych roślin, o które łatwo się pokaleczyć. Udało Ci się jednak uniknąć kłopotów.',
            badDescription2:
                'Przy drodze rośnie wiele kolczastych roślin, o które łatwo się pokaleczyć. Udało Ci się jednak uniknąć kłopotów.',
            badDescription3:
                'Przy drodze rośnie wiele kolczastych roślin, o które łatwo się pokaleczyć. Udało Ci się jednak uniknąć kłopotów.',
            badDescription4:
                'Przy drodze rośnie wiele kolczastych roślin, o które łatwo się pokaleczyć. Udało Ci się jednak uniknąć kłopotów.',
            badDescription5:
                'Przy drodze rośnie wiele kolczastych roślin, o które łatwo się pokaleczyć. Udało Ci się jednak uniknąć kłopotów.',
            badDescription6:
                'Przy drodze rośnie wiele kolczastych roślin, o które łatwo się pokaleczyć. Udało Ci się jednak uniknąć kłopotów.',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
    },
    game: {
        Village: {
            name: 'Bagienna wioska',
            effect: 'display',
            protection: 'none',
            protectedKarma: 2,
            badKarma1: 2,
            badKarma2: 'nie dotyczy',
            badKarma3: 'nie dotyczy',
            badKarma4: 'nie dotyczy',
            badKarma5: 'nie dotyczy',
            badKarma6: 'nie dotyczy',
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Mijasz wioskę, zamieszkałą przez dziwne istoty. Mają zwyczaj obrzucać obcych śmierdzącym błotem. Wiedzą co robią, bo naprawdę ciężko zmyć z siebie ten odór.',
            badDescription1:
                'Mijasz wioskę, zamieszkałą przez dziwne istoty. Mają zwyczaj obrzucać obcych śmierdzącym błotem. Wiedzą co robią, bo naprawdę ciężko zmyć z siebie ten odór.',
            badDescription2: 'nie dotyczy',
            badDescription3: 'nie dotyczy',
            badDescription4: 'nie dotyczy',
            badDescription5: 'nie dotyczy',
            badDescription6: 'nie dotyczy',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Swamps: {
            name: 'Bagna',
            effect: 'display',
            protection: 'breathing-spell',
            protectedKarma: 1,
            badKarma1: 5,
            badKarma2: 'nie dotyczy',
            badKarma3: 'nie dotyczy',
            badKarma4: 'nie dotyczy',
            badKarma5: 'nie dotyczy',
            badKarma6: 'nie dotyczy',
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Wszedłeś na bagna. Przeprawa choć uciążliwa, jest w miarę spokojna - tylko powietrze jakieś takie ciężkie, że można by topór powiesić.',
            badDescription1:
                'Wszedłeś na bagna. Przeprawa choć uciążliwa, jest w miarę spokojna - tylko te gryzące opary drażnią Twoje gardło. Niby nic się nie dzieje, ale zacząłeś dziwnie pokasływać.',
            badDescription2: 'nie dotyczy',
            badDescription3: 'nie dotyczy',
            badDescription4: 'nie dotyczy',
            badDescription5: 'nie dotyczy',
            badDescription6: 'nie dotyczy',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Mountains: {
            name: 'Góry szaleństwa',
            effect: 'toss/toss',
            protection: 'careful',
            protectedKarma: 'nie dotyczy',
            badKarma1: 7,
            badKarma2: 17,
            badKarma3: 15,
            badKarma4: 18,
            badKarma5: 10,
            badKarma6: 19,
            worseKarma1: 7,
            worseKarma2: 7,
            worseKarma3: 17,
            worseKarma4: 17,
            worseKarma5: 18,
            worseKarma6: 15,
            protectedDescription: 'nie dotyczy',
            badDescription1:
                'Aura szaleństwa sprawiła, że słyszysz głosy, które każą Ci skoczyć w przepaść. Czujesz że pomieszało Ci się w głowie, ale posłusznie podchodzisz do krawędzi i skaczesz. Żeby Cię uratować wszyscy musieli przerwać swoje zajęcia i pospieszyć Ci na ratunek.',
            badDescription2:
                'Aura szaleństwa sprawiła, że słyszysz głosy, które każą Ci skoczyć w przepaść. W ostatniej chwili oprzytomniałeś, lecz masz wrażenie że głosy w głowie pozostaną z Tobą na zawsze.',
            badDescription3:
                'Aura szaleństwa sprawiła, że słyszysz głosy, które każą Ci skoczyć w przepaść. W ostatniej chwili oprzytomniałeś, lecz masz wrażenie że głosy w głowie pozostaną z Tobą na zawsze.',
            badDescription4:
                'Górskie widoki są szalenie ciekawe. Co z tego, skoro podczas kontemplacji solidnie się wywróciłeś i porządnie potłukłeś.',
            badDescription5:
                'Górskie widoki są szalenie ciekawe. Co z tego, skoro podczas kontemplacji solidnie się wywróciłeś i rozciąłeś sobie policzek o wystający kamień.',
            badDescription6:
                'Góry jak góry: otoczenie jest monotonne do szaleństwa. Masz wrażenie że już tu kilka razy byłeś. Kręcisz się w kółko nie mogąc znaleźć właściwej drogi.',
            worseDescription1:
                'Aura szaleństwa sprawiła, że słyszysz głosy, które każą Ci skoczyć w przepaść. Czujesz że pomieszało Ci się w głowie, ale posłusznie podchodzisz do krawędzi i skaczesz. Żeby Cię uratować wszyscy musieli przerwać swoje zajęcia i pospieszyć Ci na ratunek.',
            worseDescription2:
                'Aura szaleństwa sprawiła, że słyszysz głosy, które każą Ci skoczyć w przepaść. Czujesz że pomieszało Ci się w głowie, ale posłusznie podchodzisz do krawędzi i skaczesz. Żeby Cię uratować wszyscy musieli przerwać swoje zajęcia i pospieszyć Ci na ratunek.',
            worseDescription3:
                'Aura szaleństwa sprawiła że słyszysz głosy, które każą Ci skoczyć w przepaść. W ostatniej chwili oprzytomniałeś, lecz masz wrażenie że głosy w głowie pozostaną z Tobą na zawsze.',
            worseDescription4:
                'Aura szaleństwa sprawiła że słyszysz głosy, które każą Ci skoczyć w przepaść. W ostatniej chwili oprzytomniałeś, lecz masz wrażenie że głosy w głowie pozostaną z Tobą na zawsze.',
            worseDescription5:
                'Górskie widoki są szalenie ciekawe. Co z tego, skoro podczas kontemplacji solidnie się wywróciłeś i porządnie potłukłeś.',
            worseDescription6:
                'Aura szaleństwa sprawiła że słyszysz głosy, które każą Ci skoczyć w przepaść. W ostatniej chwili oprzytomniałeś, lecz masz wrażenie że głosy w głowie pozostaną z Tobą na zawsze.',
        },
        Footbridge: {
            name: 'Kładka',
            effect: 'display',
            protection: 'helmet',
            protectedKarma: 1,
            badKarma1: 8,
            badKarma2: 'nie dotyczy',
            badKarma3: 'nie dotyczy',
            badKarma4: 'nie dotyczy',
            badKarma5: 'nie dotyczy',
            badKarma6: 'nie dotyczy',
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Wpadasz do wody bo kładka jest niestabilna. Mieszka pod nią złośliwy troll. Spodobałeś mu się, więc nie zrobił Ci krzywdy i wychodzisz bezpiecznie na drugi brzeg.',
            badDescription1:
                'Wpadasz do wody bo kładka jest niestabilna. Mieszka pod nią złośliwy troll. Nie spodobałeś mu się, więc zbił Cię maczugą - ledwo wyczołgujesz się na drugi brzeg.',
            badDescription2: 'nie dotyczy',
            badDescription3: 'nie dotyczy',
            badDescription4: 'nie dotyczy',
            badDescription5: 'nie dotyczy',
            badDescription6: 'nie dotyczy',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Avalanche: {
            name: 'Lawina kamieni',
            effect: 'display/toss',
            protection: 'helmet',
            protectedKarma: 1,
            badKarma1: 9,
            badKarma2: 9,
            badKarma3: 9,
            badKarma4: 9,
            badKarma5: 1,
            badKarma6: 1,
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Na drogę którą idziesz sypią się kamienie, ale unikasz dotkliwego uderzenia którymkolwiek z nich.',
            badDescription1:
                'Na drogę którą idziesz sypią się kamienie, a jeden z nich trafia Cię w głowę. Nie dość, że Cię zamroczyło, to jeszcze wyrasta Ci ogromny guz.',
            badDescription2:
                'Na drogę którą idziesz sypią się kamienie, a jeden z nich trafia Cię w głowę. Nie dość, że Cię zamroczyło, to jeszcze wyrasta Ci ogromny guz.',
            badDescription3:
                'Na drogę którą idziesz sypią się kamienie, a jeden z nich trafia Cię w głowę. Nie dość, że Cię zamroczyło, to jeszcze wyrasta Ci ogromny guz.',
            badDescription4:
                'Na drogę którą idziesz sypią się kamienie, a jeden z nich trafia Cię w głowę. Nie dość, że Cię zamroczyło, to jeszcze wyrasta Ci ogromny guz.',
            badDescription5:
                'Na drogę którą idziesz sypią się kamienie, ale unikasz dotkliwego uderzenia którymkolwiek z nich.',
            badDescription6:
                'Na drogę którą idziesz sypią się kamienie, ale unikasz dotkliwego uderzenia którymkolwiek z nich.',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Generator: {
            name: 'Magiczny generator',
            effect: 'generator',
            protection: 'none',
            protectedKarma: 1,
            badKarma1: 5,
            badKarma2: 15,
            badKarma3: 20,
            badKarma4: 10,
            badKarma5: 21,
            badKarma6: 1,
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Idziesz przez okolicę, po której rozsiane są nietypowe konstrukcje. Pewnie należą do magów - wszyscy wiedzą że oni budują takie dziwne rzeczy. Między słupami wesoło przeskakują magiczne iskierki. Nawet ci się podobają - w końcu rzadko masz okazję oglądać coś tak kolorowego.',
            badDescription1:
                'Idziesz przez okolicę, po której rozsiane są nietypowe konstrukcje. Pewnie należą do magów - wszyscy wiedzą że oni budują takie dziwne rzeczy. Między słupami skrzą się przepięcia i sypią magiczne iskry. Jedna z nich Cię trafia i bezskutecznie próbujesz złapać oddech. Dusisz się ale po kilku sekundach wrażenie mija. Chyba nie ma się czym przejmować.',
            badDescription2:
                'Idziesz przez okolicę, po której rozsiane są nietypowe konstrukcje. Pewnie należą do magów - wszyscy wiedzą że oni budują takie dziwne rzeczy. Między słupami skrzą się przepięcia i sypią magiczne iskry. Jedna z nich Cię trafia i nagle nie wiesz kim ani gdzie jesteś. Pamięć szwankuje ale po kilku sekundach wrażenie mija. Chyba nie ma się czym przejmować.',
            badDescription3:
                'Idziesz przez okolicę, po której rozsiane są nietypowe konstrukcje. Pewnie należą do magów - wszyscy wiedzą że oni budują takie dziwne rzeczy. Między słupami skrzą się przepięcia i sypią magiczne iskry. Jedna z nich Cię trafia i pali brwi. Odrosną, więc chyba nie ma się czym przejmować.',
            badDescription4:
                'Idziesz przez okolicę, po której rozsiane są nietypowe konstrukcje. Pewnie należą do magów - wszyscy wiedzą że oni budują takie dziwne rzeczy. Między słupami skrzą się przepięcia i sypią magiczne iskry. Jedna z nich Cię trafia i parzy w dłoń. Zagoi się, więc chyba nie ma się czym przejmować.',
            badDescription5:
                'Idziesz przez okolicę, po której rozsiane są nietypowe konstrukcje. Pewnie należą do magów - wszyscy wiedzą że oni budują takie dziwne rzeczy. Między słupami skrzą się przepięcia i sypią magiczne iskry. Jedna z nich Cię trafia i odrzuca do tyłu. Spadłeś i trochę boli ale chyba nie ma się czym przejmować.',
            badDescription6:
                'Idziesz przez okolicę, po której rozsiane są nietypowe konstrukcje. Pewnie należą do magów - wszyscy wiedzą że oni budują takie dziwne rzeczy. Między słupami skrzą się przepięcia i sypią magiczne iskry. Jedna z nich mija Cię o włos.',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Glade: {
            name: 'Myśliwska polana',
            effect: 'display',
            protection: 'breastplate',
            protectedKarma: 1,
            badKarma1: 10,
            badKarma2: 'nie dotyczy',
            badKarma3: 'nie dotyczy',
            badKarma4: 'nie dotyczy',
            badKarma5: 'nie dotyczy',
            badKarma6: 'nie dotyczy',
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Mijasz polanę, na której polują myśliwi. Machają do Ciebie radośnie z daleka.',
            badDescription1:
                'Mijasz polanę, na której polują myśliwi, a obok Ciebie właśnie przemyka lis. Słyszysz świst i czujesz ukłucie w pośladek - drasnęła Cię strzała przeznaczona dla lisa. Na szczęcie to tylko powierzchowna rana.',
            badDescription2: 'nie dotyczy',
            badDescription3: 'nie dotyczy',
            badDescription4: 'nie dotyczy',
            badDescription5: 'nie dotyczy',
            badDescription6: 'nie dotyczy',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Ruins: {
            name: 'Posępne ruiny',
            effect: 'display',
            protection: 'none',
            protectedKarma: 3,
            badKarma1: 3,
            badKarma2: 'nie dotyczy',
            badKarma3: 'nie dotyczy',
            badKarma4: 'nie dotyczy',
            badKarma5: 'nie dotyczy',
            badKarma6: 'nie dotyczy',
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Wchodzisz pomiędzy budynki, szukając krótszej drogi do celu. Ostrożnie omijasz walącą się wieżę - kiedy nagle, nie wiadomo skąd - wyskakuje na Ciebie obszarpany dziad i wyklina Cię do piątego pokolenia wstecz! Nie potrafisz przebić się przez mur obelg. Jak niepyszny umykasz z tego miejsca. Jesteś roztrzęsiony jeszcze na długo po tym szokującym spotkaniu.',
            badDescription1:
                'Wchodzisz pomiędzy budynki, szukając krótszej drogi do celu. Ostrożnie omijasz walącą się wieżę - kiedy nagle, nie wiadomo skąd - wyskakuje na Ciebie obszarpany dziad i wyklina Cię do piątego pokolenia wstecz! Nie potrafisz przebić się przez mur obelg. Jak niepyszny umykasz z tego miejsca. Jesteś roztrzęsiony jeszcze na długo po tym szokującym spotkaniu.',
            badDescription2: 'nie dotyczy',
            badDescription3: 'nie dotyczy',
            badDescription4: 'nie dotyczy',
            badDescription5: 'nie dotyczy',
            badDescription6: 'nie dotyczy',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Forest: {
            name: 'Posępny las',
            effect: 'display',
            protection: 'none',
            protectedKarma: 1,
            badKarma1: 1,
            badKarma2: 'nie dotyczy',
            badKarma3: 'nie dotyczy',
            badKarma4: 'nie dotyczy',
            badKarma5: 'nie dotyczy',
            badKarma6: 'nie dotyczy',
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Jedziesz przez las, który wygląda jakby w każdej chwili mogło na Ciebie wyskoczyć coś strasznego. Na szczęście widzisz już prześwit między drzewami, jeszcze parę kroków i będziesz bezpieczny.',
            badDescription1:
                'Jedziesz przez las, który wygląda jakby w każdej chwili mogło na Ciebie wyskoczyć coś strasznego. Na szczęście widzisz już prześwit między drzewami, jeszcze parę kroków i będziesz bezpieczny.',
            badDescription2: 'nie dotyczy',
            badDescription3: 'nie dotyczy',
            badDescription4: 'nie dotyczy',
            badDescription5: 'nie dotyczy',
            badDescription6: 'nie dotyczy',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Crossing: {
            name: 'Przeprawa wpław',
            effect: 'toss/toss',
            protection: 'breathing-spell',
            protectedKarma: 'nie dotyczy',
            badKarma1: 11,
            badKarma2: 11,
            badKarma3: 22,
            badKarma4: 22,
            badKarma5: 6,
            badKarma6: 5,
            worseKarma1: 11,
            worseKarma2: 11,
            worseKarma3: 11,
            worseKarma4: 11,
            worseKarma5: 22,
            worseKarma6: 6,
            protectedDescription: 'nie dotyczy',
            badDescription1:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Próbujesz jeszcze złapać ostatni łyk powietrza lecz nad tobą jest już tylko woda. Zachłystujesz się i toniesz a płuca zalane wodą palą Cię od wewnątrz. Ktoś na brzegu woła że trzeba Ci pomóc. Uratowali Cię, ale Twój organizm nie działa już tak jak kiedyś. Poruszasz się od tej pory nieco wolniej, potrzebujesz na wszystko więcej czasu.',
            badDescription2:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Próbujesz jeszcze złapać ostatni łyk powietrza lecz nad tobą jest już tylko woda. Zachłystujesz się i toniesz a płuca zalane wodą palą Cię od wewnątrz. Ktoś na brzegu woła że trzeba Ci pomóc. Uratowali Cię, ale Twój organizm nie działa już tak jak kiedyś. Poruszasz się od tej pory nieco wolniej, potrzebujesz na wszystko więcej czasu.',
            badDescription3:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Przepłynięcie jej to wyzwanie nawet dla takiego bohatera jak Ty. Krztusząc się wodą, ostatkiem sił dopływasz do brzegu. Czujesz że otarłeś się o śmierć i już nigdy nie będziesz tak beztroski jak kiedyś.',
            badDescription4:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Przepłynięcie jej to wyzwanie nawet dla takiego bohatera jak Ty. Krztusząc się wodą, ostatkiem sił dopływasz do brzegu. Czujesz że otarłeś się o śmierć i już nigdy nie będziesz tak beztroski jak kiedyś.',
            badDescription5:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Zachłystujesz się wodą niezliczoną ilość razy ale dopływasz na drugi brzeg. Długo łapiesz oddech i masz teraz troche charczący oddech. Myślałeś, że będzie łatwiej.',
            badDescription6:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Zachłystujesz się wodą niezliczoną ilość razy ale dopływasz na drugi brzeg. Myślałeś, że będzie łatwiej.',
            worseDescription1:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Próbujesz jeszcze złapać ostatni łyk powietrza lecz nad tobą jest już tylko woda. Zachłystujesz się i toniesz a płuca zalane wodą palą Cię od wewnątrz. Ktoś na brzegu woła że trzeba Ci pomóc. Uratowali Cię, ale Twój organizm nie działa już tak jak kiedyś. Poruszasz się od tej pory nieco wolniej, potrzebujesz na wszystko więcej czasu.',
            worseDescription2:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Próbujesz jeszcze złapać ostatni łyk powietrza lecz nad tobą jest już tylko woda. Zachłystujesz się i toniesz a płuca zalane wodą palą Cię od wewnątrz. Ktoś na brzegu woła że trzeba Ci pomóc. Uratowali Cię, ale Twój organizm nie działa już tak jak kiedyś. Poruszasz się od tej pory nieco wolniej, potrzebujesz na wszystko więcej czasu.',
            worseDescription3:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Próbujesz jeszcze złapać ostatni łyk powietrza lecz nad tobą jest już tylko woda. Zachłystujesz się i toniesz a płuca zalane wodą palą Cię od wewnątrz. Ktoś na brzegu woła że trzeba Ci pomóc. Uratowali Cię, ale Twój organizm nie działa już tak jak kiedyś. Poruszasz się od tej pory nieco wolniej, potrzebujesz na wszystko więcej czasu.',
            worseDescription4:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Próbujesz jeszcze złapać ostatni łyk powietrza lecz nad tobą jest już tylko woda. Zachłystujesz się i toniesz a płuca zalane wodą palą Cię od wewnątrz. Ktoś na brzegu woła że trzeba Ci pomóc. Uratowali Cię, ale Twój organizm nie działa już tak jak kiedyś. Poruszasz się od tej pory nieco wolniej, potrzebujesz na wszystko więcej czasu.',
            worseDescription5:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Przepłynięcie jej to wyzwanie nawet dla takiego bohatera jak ty. Krztusząc się wodą ostatkiem sił dopływasz do brzegu. Czujesz że otarłeś się o śmierć, już nigdy nie będziesz tak beztroski jak kiedyś.',
            worseDescription6:
                'Rzeka, choć wygląda na spokojną, jest bardzo zdradziecka. Zachłystujesz się wodą niezliczoną ilość razy ale dopływasz na drugi brzeg. Długo łapiesz oddech i masz teraz troche charczący oddech. Myślałeś, że będzie łatwiej.',
        },
        Dragon: {
            name: 'Smok',
            effect: 'display',
            protection: 'antiflame-spell',
            protectedKarma: 4,
            badKarma1: 12,
            badKarma2: 'nie dotyczy',
            badKarma3: 'nie dotyczy',
            badKarma4: 'nie dotyczy',
            badKarma5: 'nie dotyczy',
            badKarma6: 'nie dotyczy',
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Przechodzisz obok smoczej jaskini, budząc jej właściciela. Smok wypełza z pieczary i zieje ogniem na całą okolicę.',
            badDescription1:
                'Przechodzisz obok smoczej jaskini, budząc jej właściciela. Smok wypełza z pieczary i zieje ogniem na całą okolicę.',
            badDescription2: 'nie dotyczy',
            badDescription3: 'nie dotyczy',
            badDescription4: 'nie dotyczy',
            badDescription5: 'nie dotyczy',
            badDescription6: 'nie dotyczy',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Appiary: {
            name: 'Stara pasieka',
            effect: 'toss/toss',
            protection: 'careful',
            protectedKarma: 'nie dotyczy',
            badKarma1: 13,
            badKarma2: 2,
            badKarma3: 2,
            badKarma4: 2,
            badKarma5: 20,
            badKarma6: 20,
            worseKarma1: 13,
            worseKarma2: 13,
            worseKarma3: 13,
            worseKarma4: 2,
            worseKarma5: 2,
            worseKarma6: 2,
            protectedDescription: 'nie dotyczy',
            badDescription1:
                'Rozjuszyłeś zmutowane jadowite pszczoły. Byłeś najbliżej, więc oberwało Ci się najmocniej. Spuchnięty wyglądasz naprawdę okropnie, a dodatkowo pszczoły wyleciały z uli i żądlą każdego w Krainie. Od teraz, żeby nie umrzeć, każdy co rano będzie musiał przygotować czasochłonne antidotum.',
            badDescription2:
                'Rozjuszyłeś pszczoły. Wyleciały z ula i żądlą Cię po całej głowie. Spuchnięty wyglądasz naprawdę okropnie.',
            badDescription3:
                'Rozjuszyłeś pszczoły. Wyleciały z ula i żądlą Cię po całej głowie. Spuchnięty wyglądasz naprawdę okropnie.',
            badDescription4:
                'Rozjuszyłeś pszczoły. Wyleciały z ula i żądlą Cię po całej głowie. Spuchnięty wyglądasz naprawdę okropnie.',
            badDescription5:
                'Rozjuszyłeś pszczoły. Wyleciały z ula i żądlą Cię po całej głowie. Spuchnięty wyglądasz naprawdę okropnie.',
            badDescription6:
                'Rozjuszyłeś pszczoły. Wyleciały z ula i żądlą Cię po całej głowie. Spuchnięty wyglądasz naprawdę okropnie.',
            worseDescription1:
                'Rozjuszyłeś zmutowane jadowite pszczoły. Byłeś najbliżej, więc oberwało Ci się najmocniej. Spuchnięty wyglądasz naprawdę okropnie, a dodatkowo pszczoły wyleciały z uli i żądlą każdego w Krainie. Od teraz, żeby nie umrzeć, każdy co rano będzie musiał przygotować czasochłonne antidotum.',
            worseDescription2:
                'Rozjuszyłeś zmutowane jadowite pszczoły. Byłeś najbliżej, więc oberwało Ci się najmocniej. Spuchnięty wyglądasz naprawdę okropnie, a dodatkowo pszczoły wyleciały z uli i żądlą każdego w Krainie. Od teraz, żeby nie umrzeć, każdy co rano będzie musiał przygotować czasochłonne antidotum.',
            worseDescription3:
                'Rozjuszyłeś zmutowane jadowite pszczoły. Byłeś najbliżej, więc oberwało Ci się najmocniej. Spuchnięty wyglądasz naprawdę okropnie, a dodatkowo pszczoły wyleciały z uli i żądlą każdego w Krainie. Od teraz, żeby nie umrzeć, każdy co rano będzie musiał przygotować czasochłonne antidotum.',
            worseDescription4:
                'Rozjuszyłeś pszczoły. Wyleciały z ula i żądlą Cię po całej głowie. Spuchnięty wyglądasz naprawdę okropnie.',
            worseDescription5:
                'Rozjuszyłeś pszczoły. Wyleciały z ula i żądlą Cię po całej głowie. Spuchnięty wyglądasz naprawdę okropnie.',
            worseDescription6:
                'Rozjuszyłeś pszczoły. Wyleciały z ula i żądlą Cię po całej głowie. Spuchnięty wyglądasz naprawdę okropnie.',
        },
        Slippery: {
            name: 'Ślisko',
            effect: 'display/toss',
            protection: 'careful',
            protectedKarma: 1,
            badKarma1: 14,
            badKarma2: 23,
            badKarma3: 23,
            badKarma4: 23,
            badKarma5: 1,
            badKarma6: 1,
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Na drodze panują naprawdę niekorzystne warunki, ale szczęśliwie uniknąłeś poślizgnięcia się.',
            badDescription1:
                'Na drodze panują naprawdę niekorzystne warunki i niestety się poślizgnąłeś. Nic poważnego się nie stało, zmarnowałeś tylko resztę swojego ruchu na pozbieranie się. Poza tym przez chwilę lekko kulejesz.',
            badDescription2:
                'Na drodze panują naprawdę niekorzystne warunki i niestety się poślizgnąłeś. Nic poważnego się nie stało, lecz przez chwilę lekko kulejesz. Możesz iść pokazać to medykowi LUB zacisnąć zęby i jechać dalej -  w końcu to tylko stłuczenie.',
            badDescription3:
                'Na drodze panują naprawdę niekorzystne warunki i niestety się poślizgnąłeś. Nic poważnego się nie stało, lecz przez chwilę lekko kulejesz. Możesz iść pokazać to medykowi LUB zacisnąć zęby i jechać dalej - w końcu to tylko stłuczenie.',
            badDescription4:
                'Na drodze panują naprawdę niekorzystne warunki i niestety się poślizgnąłeś. Nic poważnego się nie stało, lecz przez chwilę lekko kulejesz. Możesz iść pokazać to medykowi LUB zacisnąć zęby i jechać dalej - w końcu to tylko stłuczenie.',
            badDescription5:
                'Na drodze panują naprawdę niekorzystne warunki, ale szczęśliwie uniknąłeś poślizgnięcia się.',
            badDescription6:
                'Na drodze panują naprawdę niekorzystne warunki, ale szczęśliwie uniknąłeś poślizgnięcia się.',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Wilderness: {
            name: 'Uroczysko',
            effect: 'display',
            protection: 'helmet',
            protectedKarma: 1,
            badKarma1: 15,
            badKarma2: 'nie dotyczy',
            badKarma3: 'nie dotyczy',
            badKarma4: 'nie dotyczy',
            badKarma5: 'nie dotyczy',
            badKarma6: 'nie dotyczy',
            worseKarma1: 'nie dotyczy',
            worseKarma2: 'nie dotyczy',
            worseKarma3: 'nie dotyczy',
            worseKarma4: 'nie dotyczy',
            worseKarma5: 'nie dotyczy',
            worseKarma6: 'nie dotyczy',
            protectedDescription:
                'Podobno na uroczysku tańczą rusałki, przy okazji kusząc śpiewem przechodniów. To nawet mogłoby być ciekawie, lecz nie dociera do Ciebie żaden śpiew. Rozczarowany idziesz dalej.',
            badDescription1:
                'Przechodząc przez uroczysko słyszysz wesoły i kuszący śpiew. Od odrobiny muzyki jeszcze nikt nie umarł. Idziesz dalej stwierdzając, że melodia przyczepiła się do Ciebie mocno i nie możesz przestać jej nucić.',
            badDescription2: 'nie dotyczy',
            badDescription3: 'nie dotyczy',
            badDescription4: 'nie dotyczy',
            badDescription5: 'nie dotyczy',
            badDescription6: 'nie dotyczy',
            worseDescription1: 'nie dotyczy',
            worseDescription2: 'nie dotyczy',
            worseDescription3: 'nie dotyczy',
            worseDescription4: 'nie dotyczy',
            worseDescription5: 'nie dotyczy',
            worseDescription6: 'nie dotyczy',
        },
        Volcano: {
            name: 'Wulkan',
            effect: 'toss/toss',
            protection: 'antiflame-spell',
            protectedKarma: 'nie dotyczy',
            badKarma1: 16,
            badKarma2: 16,
            badKarma3: 10,
            badKarma4: 10,
            badKarma5: 1,
            badKarma6: 1,
            worseKarma1: 24,
            worseKarma2: 24,
            worseKarma3: 16,
            worseKarma4: 16,
            worseKarma5: 10,
            worseKarma6: 10,
            protectedDescription: 'nie dotyczy',
            badDescription1:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się ale poraniłeś sobie przy tym ręce, a na domiar złego pryskająca lawa wypaliła Ci dziurki na twarzy.',
            badDescription2:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się ale poraniłeś sobie przy tym ręce, a na domiar złego pryskająca lawa wypaliła Ci dziurki na twarzy.',
            badDescription3:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się, ale poraniłeś sobie przy tym ręce.',
            badDescription4:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się, ale poraniłeś sobie przy tym ręce.',
            badDescription5:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, ale utrzymujesz równowagę.',
            badDescription6:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, ale utrzymujesz równowagę.',
            worseDescription1:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się ale poraniłeś sobie przy tym ręce, a na domiar złego pryskająca lawa wypaliła Ci dziurki na twarzy.',
            worseDescription2:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się ale poraniłeś sobie przy tym ręce, a na domiar złego pryskająca lawa wypaliła Ci dziurki na twarzy.',
            worseDescription3:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się ale poraniłeś sobie przy tym ręce, a na domiar złego pryskająca lawa wypaliła Ci dziurki na twarzy.',
            worseDescription4:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się ale poraniłeś sobie przy tym ręce, a na domiar złego pryskająca lawa wypaliła Ci dziurki na twarzy.',
            worseDescription5:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się, ale poraniłeś sobie przy tym ręce.',
            worseDescription6:
                'Ścieżka biegnie brzegiem krateru. Kiedy nią idziesz ziemia osuwa Ci się spod nóg, więc chroniąc się przed wpadnięciem do lawy, łapiesz się ostrej krawędzi głazu. Wygrzebałeś się, ale poraniłeś sobie przy tym ręce.',
        },
    },
};
